/**
 * Resolves orgSlug from a custom domain hostname.
 * Fills the gap where detectTenant() returns orgSlug: null for custom domains.
 */
const API_BASE = import.meta.env.VITE_API_URL || "";

// Unbounded but safe: max 1-2 entries per session (one per custom domain)
const cache: Record<string, string> = {};

export async function resolveOrgFromHostname(hostname: string): Promise<string> {
  if (cache[hostname]) return cache[hostname];

  const res = await fetch(
    `${API_BASE}/visitor/resolve-org?hostname=${encodeURIComponent(hostname)}`
  );
  if (!res.ok) {
    throw new Error(`Failed to resolve org for hostname: ${hostname}`);
  }

  const data: { orgSlug: string } = await res.json();
  cache[hostname] = data.orgSlug;
  return data.orgSlug;
}
